<div data-testid="criteria-evaluation-ec3-page">
  @if (hasModules()) {
    <p-tabs
      appTabsUnsavedReveal
      [value]="activeModuleTabIndex()"
      (valueChange)="onModuleSelected($event!)"
      class="module-tabs"
      scrollable
      data-testid="module-tabs"
    >
      <p-tablist data-testid="module-tablist">
        @for (module of moduleGroups(); track module.moduleId) {
          <p-tab
            [value]="$index"
            [appTabStatus]="module.status"
            [attr.data-testid]="'module-tab-' + module.moduleId"
          >
            {{ (module.translations | translateDirectus: 'name' : true) ?? module.name }}
          </p-tab>
        }
      </p-tablist>
      <p-tabpanels class="mt-2" data-testid="module-tabpanels">
        <p-card data-testid="module-card">
          @for (module of moduleGroups(); track module.moduleId) {
            <p-tabpanel [value]="$index" [attr.data-testid]="'module-tabpanel-' + module.moduleId">
              @if (openedModuleTabIndexes().has($index)) {
                <div>
                  <div class="flex justify-between items-center">
                    <h2 class="text-2xl font-bold">
                      {{ 'project.steps.ec3.functions.title' | transloco }}
                    </h2>
                  </div>

                  <p-tabs
                    appTabsUnsavedReveal
                    [value]="activeSubCriteriaTabIndex()"
                    (valueChange)="onSubCriteriaSelected($event!)"
                    class="subcriteria-tabs"
                    scrollable
                    data-testid="subcriteria-tabs"
                  >
                    <p-tablist data-testid="subcriteria-tablist">
                      @for (panel of module.panels; track panel.id) {
                        <p-tab
                          [value]="$index"
                          [appTabStatus]="panel.status"
                          [attr.data-testid]="'subcriteria-tab-' + panel.id"
                        >
                          {{ panel.translations | translateDirectus }}
                          @if (showConsistency() && panel.unresolvedConsistencyCount > 0) {
                            <i
                              class="pi pi-exclamation-triangle ml-2 text-sm"
                              [style.color]="
                                panel.clarificationConsistencyCount > 0
                                  ? consistencyClarificationColor
                                  : consistencyWarningColor
                              "
                              [pTooltip]="'evaluation.consistency.tabWarning' | transloco"
                              [attr.data-testid]="'subcriteria-tab-warning-' + panel.id"
                            ></i>
                          }
                        </p-tab>
                      }
                    </p-tablist>
                    <p-tabpanels class="mt-4" data-testid="subcriteria-tabpanels">
                      @for (panel of module.panels; track panel.id) {
                        <p-tabpanel
                          [value]="$index"
                          [attr.data-testid]="'subcriteria-tabpanel-' + panel.id"
                        >
                          <app-sub-criteria-tab
                            [subCriteriaPanel]="panel"
                            [disabled]="disabled()"
                            [projectId]="projectId()"
                            [phase]="phase"
                            [showConsistency]="showConsistency()"
                            [lastSaveAuditInfo]="lastSaveAuditInfo()"
                            (scoreSelected)="onScoreSelected($event)"
                            (save)="onSave(panel.id)"
                            (consistencyChanged)="consistencyChanged.emit($event)"
                          />
                        </p-tabpanel>
                      }
                    </p-tabpanels>
                  </p-tabs>
                </div>
              }
            </p-tabpanel>
          }
        </p-card>
      </p-tabpanels>
    </p-tabs>
  } @else {
    <div class="text-center py-8">
      <p>{{ 'project.steps.noModulesWithSubCriteria' | transloco }}</p>
    </div>
  }
</div>
